<script>

    import StatisticsQuotationsService from '../$services/statistics.quotations.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Card from './component.quotations.card.svelte'

    export let dateStart = null
    export let dateEnd = null
    export let title = ''
    export let label = ''
    export let source = 'providers'

    let items = []
    let loaded = false
    let loading = false
    let error = false
    let seq = 0

    $: load(dateStart, dateEnd)

    async function load(start, end) {
        if (!start || !end) return

        const id = ++seq
        const request = source === 'partners'
            ? StatisticsQuotationsService.getPartners
            : StatisticsQuotationsService.getProviders

        loading = true
        const res = await request({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        // si el periodo cambió mientras cargaba, esta respuesta ya no aplica
        if (id !== seq) return

        loading = false
        error = !res?.success
        items = res?.success ? res.data.items : []
        loaded = !error
    }

    function percent(value) {
        return `${Number(value).toFixed(1)}%`
    }

</script>

<style>
    .table-wrap {
        overflow-x: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.9rem;
    }

    th {
        padding: 0.55rem 0.5rem;
        text-align: right;
        vertical-align: bottom;
        font-weight: 600;
        color: #374151;
        border-bottom: 1px solid #e5e7eb;
    }

    td {
        padding: 0.8rem 0.5rem;
        text-align: right;
        color: #1a1a1a;
        border-bottom: 1px solid #f1f1f1;
        font-variant-numeric: tabular-nums;
    }

    th:first-child,
    td:first-child {
        text-align: left;
        padding-left: 0;
    }

    th:last-child,
    td:last-child {
        padding-right: 0;
    }

    tr:last-child td {
        border-bottom: 0;
    }
</style>

<Card { title } { loading } { error } empty={ loaded && !items.length }>
    <div class="table-wrap">
        <table>
            <thead>
                <tr>
                    <th>{ label }</th>
                    <th>Veces mostrada</th>
                    <th>Veces seleccionada</th>
                    <th>% selección</th>
                    <th>Guías generadas</th>
                    <th>Conversión tras selección</th>
                </tr>
            </thead>
            <tbody>
                {#each items as item (item.name)}
                    <tr>
                        <td>{ item.name }</td>
                        <td>{ NumeralMethods.number(item.shown) }</td>
                        <td>{ NumeralMethods.number(item.selected) }</td>
                        <td>{ percent(item.selection) }</td>
                        <td>{ NumeralMethods.number(item.generated) }</td>
                        <td>{ percent(item.conversion) }</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</Card>
